module.exports = __webpack_public_path__ + "static/media/Thumbs.f1ba9ef4.db";